<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">店员补贴&nbsp;/&nbsp;</span>
      </div>
      <div>店员补贴记录</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <div>
              <el-date-picker v-model="query.dataMonth" type="month" value-format="yyyy-MM" placeholder="选择月"
                @change="totalCounts" :clearable="false"></el-date-picker>
              <el-select v-model="query.auditStatus" placeholder="全部状态" filterable @change="selectChange" class="ml10">
                <el-option v-for="item in option1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="query.subsidyType" placeholder="补贴类型" filterable @change="selectChange" class="ml10">
                <el-option label="补贴类型" value></el-option>
                <el-option v-for="item in option2" :key="item.value" :label="item.text" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="addSubsidies"
              v-perm="{ key: 'staffSubsidy', value: 'staffSubsidy:add' }">新增补贴</el-button>
          </div>
          <div class="plr16" v-perm="{ key: 'staffSubsidy', value: 'staffSubsidy:list' }">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="subsidyTypeCn" label="补贴类型"></el-table-column>
              <el-table-column prop="staffName" label="补贴店员" width="auto"></el-table-column>
              <el-table-column prop="auditAmount" width="auto" label="补贴金额">
                <template slot-scope="scope">
                  <span class="moneys">￥{{ scope.row.auditAmount == 0 ?
                    scope.row.applyAmount : scope.row.auditAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
              <el-table-column prop="oxCtime" width="auto" label="创建时间">
                <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.oxCtime) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" @click="details(scope.row)">查看详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail ref="detailForm" @change="auditBack"></detail>
    <add ref="addForm" @change="auditBack"></add>
  </div>
  <!-- <div class="cookAllowance">
    <div class="p16 align-items">
      <div>店员补贴</div>
    </div>
    <div class="white mains-content">
      <div>
        <div class="comingSoon-img"><img src="../../../assets/images/new/comingSoon.png" alt=""></div>
        <div class="comingSoon-title">功能开发中，敬请期待</div>
      </div>
    </div>
  </div> -->
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detail from "./detail.vue";
import add from "./add.vue";
export default {
  data() {
    return {
      url: this.$url.subsidyApply.list,
      urlCount: this.$url.subsidyApply.count,
      query: {
        dataMonth: "",
        auditStatus: "",
        subsidyType: "",
        start: 0,
        size: 20
      },
      option1: [{
        label: "全部状态",
        value: ""
      },
      {
        label: "待审核",
        value: "wait"
      },
      {
        label: "通过",
        value: "pass"
      },
      {
        label: "拒绝",
        value: "refuse"
      },
      {
        label: "处理中",
        value: "processing"
      },
      {
        label: "取消",
        value: "cancel"
      },
      ],
      option2: [
        {
          text: "全勤补贴",
          value: "fullAttendance"
        },
        {
          text: "工龄补贴",
          value: "workAge"
        },
        {
          text: "入职补助",
          value: "guarantee"
        },
        {
          text: "其他补贴",
          value: "other"
        },
        {
          text: "疫情补贴",
          value: "epidemic"
        },
        {
          text: "厨师补贴",
          value: "chef"
        },
        {
          text: "收银补贴",
          value: "cashier"
        },
        {
          text: "车费补贴",
          value: "fare"
        },
        {
          text: "体检补贴",
          value: "healthCheck"
        },
        {
          text: "综合补贴",
          value: "socialReimburse"
        },
        {
          text: "爱心捐款",
          value: "loveDonation"
        },
        {
          text: "乐捐",
          value: "voluntarilyDonation"
        },
        {
          text: "师带徒奖励",
          value: "teach"
        },
        {
          text: "师带徒考核",
          value: "teachCheck"
        },
        {
          text: "品质战奖励",
          value: "quality"
        },
        {
          text: "品质战考核",
          value: "qualityCheck"
        },
        {
          text: "免脚补贴",
          value: "noFoot"
        },
        {
          text: "入职补助扣回",
          value: "guaranteeReduce"
        },
        {
          text: "车费扣回",
          value: "fareReduce"
        },
        {
          text: "体检扣回",
          value: "healthCheckReduce"
        },
        {
          text: "副店长补贴",
          value: "viceShopManager"
        },
        {
          text: "工服补贴",
          value: "coverall"
        },
        {
          text: "床品补贴",
          value: "bedding"
        },
        {
          text: "打卡考核",
          value: "attendance"
        },
        {
          text: "旷工考核",
          value: "noAttendance"
        },
        {
          text: "工服扣回",
          value: "coverallReduce"
        },
        {
          text: "床品扣回",
          value: "beddingReduce"
        },
        {
          text: "开业打扫补贴",
          value: "openCleanSubsidy"
        },
        {
          text: "社保扣款",
          value: "socialSecurityReduce"
        },
      ],
      height: this.$store.getters.MainHeight,
      list: []
    };
  },
  mixins: [minxin],
  components: { detail, add },
  computed: {},

  created() {
    this.query.dataMonth = this.formatMonth(new Date())
    this.totalCounts();
  },

  methods: {
    details(row) {
      this.$refs["detailForm"].$emit("set", row.id);
    },
    back() {
      this.$router.push("/dataList/attendancePunch");
    },
    auditBack() {
      this.totalCounts();
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts() {
      this.$api.post(this.urlCount, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    addSubsidies() {
      this.$refs["addForm"].$emit("set");
    },
    getAllSubsidyType() {
      this.$api.get(this.$url.subsidyApply.getAllSubsidyType).then(res => {
        console.log(res)
        this.option2 = res;
      })
    },
    back () {
      this.$router.push("/dataList/staffSubsidy");
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}

.mains-content {
  height: calc(100% - 72px);

  .member-content-box {
    background: #fff;
  }

  .member-header {

    padding: 16px;
    display: flex;
  }
}

.cookAllowance {
  height: 100%;

  .mains-content {
    margin: 0 16px;
    height: calc(100vh - 127px);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;

    .comingSoon-img {
      width: 170px;
      height: 170px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .comingSoon-title {
      text-align: center;
      margin-top: 20px;
      color: #A7A7A7;
      font-size: 16px;
    }
  }
}</style>